import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/galveston")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Galveston, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Galveston & Galveston County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Galveston, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Galveston and Galveston County.",
      keywords: "awnings Galveston, awning company Galveston, custom awnings Galveston, sail shades Galveston, patio covers Galveston, pergola covers Galveston, metal awnings Galveston, canvas awnings Galveston, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Galveston", "Galveston County"),
  }),
  component: () => <CityHomePage city="Galveston" region="Galveston County" />,
});
